import { Injectable, Signal, inject } from '@angular/core';
import { DefaultStoreStore } from './default-store.store';
import { Observable } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class DefaultStoreFacade {
  private store: DefaultStoreStore = inject(DefaultStoreStore);

  public waitingForCheck: Signal<boolean> = this.store.waitingForCheck;
  public waitingForCheck$: Observable<boolean> = toObservable(this.store.waitingForCheck);

  public loading: Signal<boolean> = this.store.loading;
  public loading$: Observable<boolean> = toObservable(this.store.loading);

  public defaultStore(regionSlug: string, utmCampaign?: string, utmUserMode?: string): void {
    this.store.defaultStore(regionSlug, utmCampaign, utmUserMode);
  }

  public checkNotNeeded(): void {
    this.store.checkNotNeeded();
  }
}
